import { CrudFb60Service } from './../../../services/crud-fb60/crud-fb60.service';
import { CatalogsService } from './../../../services/catalogs/catalogs.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Validators, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ToasterModule, ToasterService, Toast, ToasterConfig } from 'angular5-toaster';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError } from 'rxjs/operators';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';
import { StorageService } from '../../../services/storage.service';
import { User } from '../../../models/user';

@Component({
  selector: 'app-add-modal',
  templateUrl: './add-modal.component.html',
  styleUrls: ['./add-modal.component.scss'],
  providers: [CrudFb60Service, CatalogsService]
})
export class AddModalComponent implements OnInit {

  public user: User;
  closeResult: string;
  claveProductoSat;
  descripcion;
  cuentaContable;
  centroCosto;
  respuesta;
  modalMensaje;
  salida = {
    clavesSAT: []
  };

  cuentasm$: Observable<any>;
  cuentasmLoading = false;
  cuentasminput$ = new Subject<string>();

  cecos$: Observable<any>;
  cecosLoading = false;
  cecosinput$ = new Subject<string>();

  busy: boolean = false;
  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });
  constructor(
    private storageService: StorageService,
    private crudFb60Service: CrudFb60Service,
    private catalogos: CatalogsService,
    public activeModal: NgbActiveModal,
    private toasterService: ToasterService,
    private modalService: NgbModal
  ) {
    this.getCuentaDeMayor();
    this.getCecos();
  }

  ngOnInit() {
    this.user = this.storageService.getCurrentUser();
  }

  closeModal() {
    this.activeModal.close('Modal Closed');
  }

  getCuentaDeMayor() {
    this.cuentasm$ = concat(of([]),
      this.cuentasminput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),

        tap(() => this.cuentasmLoading = true),
        switchMap(term =>
          this.catalogos.obtenerCuentaDeMayor(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => this.cuentasmLoading = false)
          ))
      )
    );
  }

  getCecos() {
    this.cecos$ = concat(of([]),
      this.cecosinput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),

        tap(() => this.cecosLoading = true),
        switchMap(term =>
          this.catalogos.obtenerCecos(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => this.cecosLoading = false)
          ))
      )
    );
  }

  guardarProductos(file1: File) {
    const formData: FormData = new FormData();
    formData.append('archivoexcel', file1);

    if (file1) {
      this.crudFb60Service.guardarCargaProductos(formData).subscribe(
        data => {
          const respuesta = data.result;
          this.activeModal.close();
          // this.busy = false;
          //  this.openMensajeRespuesta(mensajeRes);
        },
        err => {
          if (err.status === 401) {
            this.storageService.openLogout();
          }
        },
      );
    } 

  }

  crearProductos(mensaje) {
    let claveProductoSat = this.claveProductoSat;
    let descripcion = this.descripcion;
    let cuentaContable = this.cuentaContable;
    let centroCosto = this.centroCosto;

    if (claveProductoSat === null || claveProductoSat === undefined || claveProductoSat === '') {
      claveProductoSat = '';
    }

    if (descripcion === null || descripcion === undefined || descripcion === '') {
      descripcion = '';
    }

    if (cuentaContable === null || cuentaContable === undefined || cuentaContable === '') {
      cuentaContable = '';
    }

    if (centroCosto === null || centroCosto === undefined || centroCosto === '') {
      centroCosto = '';
    }

    if (claveProductoSat === '' || descripcion === '' || cuentaContable === '' || centroCosto === '') {

      // console.log('nooo');

    } else {

      let crearProductos: any = {
        claveProductoSat: claveProductoSat,
        descripcion: descripcion,
        cuentaContable: cuentaContable,
        centroCosto: centroCosto
      };

      crearProductos = JSON.stringify(crearProductos);

      this.crudFb60Service.postCargaProductos(crearProductos).subscribe(
        data => {
          this.respuesta = data.result.message;
          this.activeModal.close('s');
          this.openMensaje(mensaje);
        },
        err => {
          if (err.status === 401) {
            this.storageService.openLogout();
          }
        },
      );

    }
  }

  openMensaje(mensaje) {
    this.modalMensaje = this.modalService.open(mensaje, { centered: true, keyboard: false, backdrop: 'static' });
    this.modalMensaje.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReasonFiltersOC(reason)}`;
    });
  }

  private getDismissReasonFiltersOC(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}




// WEBPACK FOOTER //
// ./src/app/pages/crud-fb60/add-modal/add-modal.component.ts